import {DOKAI_BASE_URL, DOKAI_PAGE_NAME} from '../../constants'

const logPath = (route: string) => {
	console.log(`***Opening Dokai*** --> ${route}`)
}

export const openDokai = (location: any) => {
	const location_split = location.pathname.split('/')
	let url = ''
	if (location.pathname === '/') {
		url = DOKAI_BASE_URL + '/dashboard'
		logPath(url)
		window.open(url, DOKAI_PAGE_NAME)
		return
	}
	// show the intro page for the about screen
	if (location.pathname === '/about') {
		url = 'https://help.mokai.ch/docs/intro'
		logPath(url)
		window.open(url, DOKAI_PAGE_NAME)
		return
	}

	if (!isNaN(parseInt(location_split[location_split.length - 1]))) { 
		// 1 because the first one is gonna be the empty string
		url = `${DOKAI_BASE_URL}/${location_split[1]}/detail`
		logPath(url)
		window.open(url, DOKAI_PAGE_NAME)
		return
	}
	// default back to non-specialized view
	url = DOKAI_BASE_URL + location.pathname
	logPath(url)
	window.open(url, DOKAI_PAGE_NAME)

}